import type { CountryData } from 'country-region-data';

import { AppConfig } from './AppConfig';
import env from './loadEnv';

export const getBaseUrl = () => {
  if (env.VITE_APP_URL) {
    return env.VITE_APP_URL;
  }

  return 'http://localhost:3001';
};

export const getI18nPath = (url: string, locale: string) => {
  if (locale === AppConfig.defaultLocale) {
    return url;
  }

  return `/${locale}${url}`;
};

export type Region = {
  name: string;
  shortCode: string;
};

export const filterCountries = (
  countries: CountryData[],
  priorityCountries: string[],
  whitelist: string[],
  blacklist: string[],
): CountryData[] => {
  const countriesListedFirst: any[] = [];
  let filteredCountries = countries;
  if (whitelist.length > 0) {
    filteredCountries = countries.filter(
      ([, countrySlug]) => whitelist.includes(countrySlug),
    );
  } else if (blacklist.length > 0) {
    filteredCountries = countries.filter(
      ([, countrySlug]) => !blacklist.includes(countrySlug),
    );
  }

  if (priorityCountries.length > 0) {
    // ensure the countries are added in the order in which they are specified by the user
    priorityCountries.forEach((slug) => {
      const result = filteredCountries.find(
        ([, countrySlug]) => countrySlug === slug,
      );
      if (result) {
        countriesListedFirst.push(result);
      }
    });

    filteredCountries = filteredCountries.filter(
      ([, countrySlug]) =>
        !priorityCountries.includes(countrySlug),
    );
  }

  return countriesListedFirst.length
    ? [...countriesListedFirst, ...filteredCountries]
    : filteredCountries;
};

export const filterRegions = (
  regions: Region[],
  priorityRegions: string[],
  whitelist: string[],
  blacklist: string[],
) => {
  const regionsListedFirst: any[] = [];
  let filteredRegions = regions;

  if (whitelist.length > 0) {
    filteredRegions = regions.filter(
      ({ shortCode }) => whitelist.includes(shortCode),
    );
  } else if (blacklist.length > 0) {
    filteredRegions = regions.filter(
      ({ shortCode }) => !blacklist.includes(shortCode),
    );
  }

  if (priorityRegions.length > 0) {
    // ensure the Regions are added in the order in which they are specified by the user
    priorityRegions.forEach((slug) => {
      const result = filteredRegions.find(
        ({ shortCode }) => shortCode === slug,
      );
      if (result) {
        regionsListedFirst.push(result);
      }
    });

    filteredRegions = filteredRegions.filter(
      ({ shortCode }) => !priorityRegions.includes(shortCode),
    );
  }

  return regionsListedFirst.length
    ? [...regionsListedFirst, ...filteredRegions]
    : filteredRegions;
};
